import React, { useRef, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import { useHistory, useLocation } from "react-router";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";

import MenuList from "~/components/Blocks/MenuList";
import { GetMenuGroupList, MenuSet } from "~slices/Menu";

import InputPartyDate from "~/components/Atoms/InputPartyDate";
import { formatDate } from "~/functions/FormatDate";

const Top = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    //詳細表示プラン

    const menu_state = useSelector((state) => state.Menu);
    const menu_group_list = menu_state.menu_group_list;
    const selected_group = menu_state.selected_group;
    let [party_date, set_party_date] = React.useState(party_date);
    const [getMenuFirst, setGetMenuFirst] = useState(false);
    const regex = /年|月|日/g;

    const HandleClick = (selected_group_data) => {
        dispatch(MenuSet(["selected_group", selected_group_data]));
    };

    useEffect(() => {
        if(!party_date) return;
        if(getMenuFirst) return;
        const params = {
            party_date: party_date.replaceAll(regex, "/").slice(0, -1)
        }
        dispatch(GetMenuGroupList(params)).then((data) => {
            data?.payload?.menu_group_list?.length &&
                setMenu(data.payload.menu_group_list);
        });
        setGetMenuFirst(true);
    }, [party_date]);

    //この開催日で予約する
    const getMenuClick = (e) => {
        e.preventDefault();

        const params = {
            party_date: party_date.replaceAll(regex, "/").slice(0, -1)
        }
        dispatch(GetMenuGroupList(params)).then((data) => {
            data?.payload?.menu_group_list?.length &&
                setMenu(data.payload.menu_group_list);
        });
    }

    const setMenu = (list) => {
        for(let group of list)
        {
            if(group.menu_data.length > 0)
            {
                //選択可能な商品が存在するグループの先頭を選択
                dispatch(MenuSet(["selected_group", group]));
                break;
            }
        }
    };

    //このコースで予約する
    const applicate = (e) => {

        const params = {
            party_date: party_date,
            menu_group_id: selected_group["menu_group_id"],
        };

        const urlSearchParam = new URLSearchParams(params).toString();
        history.push(`/ApplicationForm?${urlSearchParam}`);
    };

    const changeDate = (val) => {
        //メニューリストに選択日付を渡す
        set_party_date(formatDate(val, 'YYYY年MM月DD日'));
    }

    return (
        <React.Fragment>
            {/* <Container> */}
            <img src="/images/Top/yahoo_online_howto_top1.png" width="100%" />
            <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ mb: 3 }}>
                <Button variant="contained" href="#reserver" fullWidth sx={{ maxWidth: "30rem", lineHeight:"2.75", color: "white", fontWeight: "bold" }}>
                    今すぐ申し込む
                </Button>
            </Grid>

            <img src="/images/Top/yahoo_online_howto_fix0726.png" width="100%" />

            <form
                onSubmit={getMenuClick}
                // style={{
                //     backgroundImage: `url(/images/Top/water_00001.jpg)`,
                //     backgroundSize: "100%",
                //     minHeight: "30rem",
                //     backgroundRepeat: "no-repeat",
                // }}
                id="reserver"
            >

                <Grid
                    id="reserver"
                    container
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        p: 5,
                    }}
                    direction="column"
                >
                    <Typography
                        variant="h6"
                        sx={{
                            p: "1rem",
                        }}
                    >
                        開催日を選択して予約する
                        <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            sx={{ maxWidth: "350px", fontSize: "0.7rem" }}
                        >
                            {"開催日の6営業日前23:59までにお申込みください。"}
                        </Grid>
                    </Typography>
                    <Grid container justifyContent="center" alignItems="center">
                        <InputPartyDate
                            sx={{
                                maxWidth: "12rem",
                                mr: "5px",
                            }}
                            changeDate={(val) => changeDate(val)}
                        />

                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            sx={{ml: "5px"}}
                        >
                            ①この開催日で予約する
                        </Button>
                    </Grid>
                </Grid>

                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                    sx={{
                        bgcolor: "primary.light",
                        pb: 2,
                    }}
                >
                    <Grid container direction="row" justifyContent="space-around" alignItems="center" spacing={2} sx={{mt: 2}}>
                        {menu_group_list.map((menu_list, index) => (
                            <React.Fragment key={index}>
                                {menu_list.menu_data.length > 0 && (
                                    <Chip
                                        sx={{
                                            fontSize: "2rem",
                                            p: "0.5rem",
                                            m: "0.5rem",
                                            background:
                                                selected_group?.menu_group_id == menu_list?.menu_group_id
                                                    ? "rgba(0, 0, 0, 0.12)"
                                                    : "#fff",
                                            color: 
                                                selected_group?.menu_group_id == menu_list?.menu_group_id
                                                    ? "#000000de"
                                                    : "#00000045"
                                        }}
                                        // color="warning"
                                        // variant="outlined"
                                        label={menu_list.menu_group_name}
                                        onClick={() => HandleClick(menu_list)}
                                    />
                                )}
                            </React.Fragment>
                        ))}
                    </Grid>

                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        direction="column"
                        style={{ display: menu_group_list.length === 0 ? 'none' : '' }}
                    >
                        <Button
                            sx={{
                                color: "white",
                                padding: "1.2rem",
                                fontSize: "large",
                                border: "solid white 2px",
                            }}
                            variant="contained"
                            color="primary"
                            disabled={selected_group.menu_data?.length > 0 ? false : true}
                            onClick={applicate}
                        >
                            ②このコースを選択する
                        </Button>
                    </Grid>
                </Stack>
            </form>

            <Grid
                container
                justifyContent="center"
                sx={{
                    background: "#ffe4c5",
                    pb: 5,
                }}
            >
                <MenuList
                    menu_group_id={selected_group.menu_group_id}
                    menu_list={selected_group ? selected_group.menu_data : []}
                    app_button
                    party_date={party_date}
                />
            </Grid>
        </React.Fragment>
    );
};

export default Top;
